import { Flex } from 'antd'
import React from 'react'
import { DesignSystem } from '~/core/designSystem'
import { ButtonCTA } from '~/features/shared/components'
import { usePwaContext } from '../../context'
import { IphoneNotification } from '../IphoneNotification'

export const InstallationHelp: React.FC = () => {
  const pwa = usePwaContext()
  const designSystem = DesignSystem.use()

  const handleClick = () => {
    if (designSystem.isMobile) {
      pwa.installation.setVisible(true)
    } else {
      pwa.promotion.setVisible(true)
    }
  }

  return (
    <Flex vertical gap={16} align="center">
      <IphoneNotification />
      <ButtonCTA style={{ maxWidth: '340px' }} onClick={handleClick}>
        Get Mobile App
      </ButtonCTA>
    </Flex>
  )
}
